/* Next */
import Link from 'src/components/Link'

/* Redux */
import Redux from '../../Wunschliste.Redux'
import { useSelector } from 'src/redux/hooks'

/* Types */
import { tProductPreview } from 'src/shared/frontendTypes/product'

/* Material */
import Typo from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Button from '@mui/material/Button'
import useStyles from './styles'

/* Material-Icons */
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined'
import ClearIcon from '@mui/icons-material/Clear'

/* Functions */
import getImageUrl from 'src/pages/Product/functions/imageUrl'
import getProductUrl from 'src/functions/productUrl'
import { isQuantityDiscountAvailable } from 'src/shared/discountShop'

/* Components */
import PriceDisplay from 'src/components/PriceDisplay'
import AiGeneratedBadge from 'src/components/AiGeneratedBadge'
import DiscountInfos from 'src/components/DiscountInfos'

interface Props {
  item: [string, { id: number }]
  product: tProductPreview
}

const Item: React.FC<Props> = ({ item, product }) => {
  const classes = useStyles()
  const { deleteItem } = Redux()
  const touchDevice = useSelector(store => store.App.isTouchDevice)

  const [key, { id }] = item
  if (!product) return null

  const {
    name, metaTitle, price, discount, images, path, attributes, options, onlyStock, stock
  } = product
  const showQuantityDiscount = discount
    && discount.showPercent !== false
    ? isQuantityDiscountAvailable(discount.quantityDiscount, {
      onlyStock,
      stock,
    })
    : false

  /* ---------------------------------------------------------------- */

  const productUrl = getProductUrl(id, path, options)
  const imageUrl = getImageUrl(images[0],id,'xs')

  /* ---------------------------------------------------------------- */
  return <Card className={[
    classes.card,
    !touchDevice ? 'hover' : null
  ].join(' ')}>

    <CardContent className={classes.content}>
      <div className={classes.gridRoot}>


        <Link href={productUrl} passHref legacyBehavior>
          <Card className={classes.image} role='button'>
            {imageUrl && <>
              <img
                alt={name}
                src={imageUrl}
                width={100} height={100}
                loading='eager'
              />
              <AiGeneratedBadge aiGenerated={images[0]?.aiGenerated} />
            </>}
          </Card>
        </Link>


        <div className={classes.gridInfos}>

          <div className={classes.titel}>
            <Link href={productUrl} passHref legacyBehavior>
              <Typo component='a' fontWeight='bold'>
                  {metaTitle}
              </Typo>
            </Link>
          </div>
          
          {attributes && 
            <div className={classes.description}>
              <List>
                {attributes.map((attribute,i)=>
                  <ListItem key={i} component='li'>
                    {attribute}
                  </ListItem>
                )}
              </List>
            </div>
          }

          <div className={classes.price}>

            {discount && (
              <DiscountInfos
                discount={{
                  title: discount.metaTitle,
                  type:  discount.type,
                  countdownVariant: discount.countdownVariant,
                  dateEnd: discount.dateEnd,
                  regularPrice: price,
                  discountPrice: discount.price,
                  discountPriceAfterStock: discount.priceAfterStock,
                  stockDiscountLimit: discount.stockDiscountLimit,
                  limitStockDiscountToStock: discount.limitStockDiscountToStock,
                  quantityDiscount: discount.quantityDiscount,
                  showPercent: discount.showPercent,
                }}
                component='div'
                variant='h5'
                align='center'
                className={classes.discountInfos}
                clock={{ variant: 'h5' }}
                size='small'
                showQuantityDiscount={showQuantityDiscount}
              />
            )}

            <PriceDisplay 
              price={discount 
                ? {
                  regularPrice:  price,
                  discountPrice: discount.price,
                  discountPriceAfterStock: discount.priceAfterStock,
                  stockDiscountLimit: discount.stockDiscountLimit,
                  limitStockDiscountToStock: discount.limitStockDiscountToStock,
                  quantityDiscount: discount.quantityDiscount,
                  title:         discount.metaTitle,
                  type:          discount.type,
                  countdownVariant: discount.countdownVariant,
                  dateEnd:       discount.dateEnd,
                  showPercent:   discount.showPercent,
                } 
                : price
              }
              component='p' variant='body1' align='right'
              onlyStock={onlyStock}
              stock={stock}
            />

          </div>
          
          <div className={classes.buttons}>
            <Button 
              title="Entfernen"
              size='small' color='inherit' variant='outlined'
              onClick={()=>{deleteItem(key)}}
            >
              <ClearIcon />
            </Button>
            <Link href={productUrl} passHref legacyBehavior>
              <Button
                size='small' color='inherit' variant='outlined'
                startIcon={<LocalMallOutlinedIcon />}
              >
                Zum Produkt
              </Button>
            </Link>
          </div>
          
        </div>
        

      </div>
    </CardContent>
  </Card>
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

}

export default Item
